import React, { useState } from 'react';
import { companyInfo } from '../data/mock';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../data/translations';

const Contact = () => {
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(t('contact.form.successMessage'));
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  return (
    <section id="contact" className="contact-section">
      <div className="section-header">
        <h2 className="display-large section-title">{t('contact.title')}</h2>
        <p className="body-large section-subtitle">
          {t('contact.subtitle')}
        </p>
      </div>

      <div className="contact-content">
        <div className="contact-info">
          <div className="contact-info-item">
            <div className="contact-icon-wrapper">
              <Mail size={24} />
            </div>
            <div>
              <h3 className="heading-3">{t('contact.email')}</h3>
              <p className="body-medium">{companyInfo.contact.email}</p>
            </div>
          </div>

          <div className="contact-info-item">
            <div className="contact-icon-wrapper">
              <Phone size={24} />
            </div>
            <div>
              <h3 className="heading-3">{t('contact.phone')}</h3>
              <p className="body-medium">{companyInfo.contact.phone1} • {companyInfo.contact.phone2}</p>
            </div>
          </div>

          <div className="contact-info-item">
            <div className="contact-icon-wrapper">
              <MapPin size={24} />
            </div>
            <div>
              <h3 className="heading-3">{t('contact.office')}</h3>
              <p className="body-medium">{companyInfo.contact.address}</p>
              <p className="body-medium">{t('contact.pobox')}: {companyInfo.contact.pobox}, {companyInfo.contact.city} - {t('contact.country')}</p>
            </div>
          </div>
        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name" className="form-label">{t('contact.form.name')}</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="form-input"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email" className="form-label">{t('contact.form.email')}</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="form-input"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone" className="form-label">{t('contact.form.phone')}</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="message" className="form-label">{t('contact.form.message')}</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="form-textarea"
              rows="5"
              required
            />
          </div>

          <button type="submit" className="btn-primary" style={{ width: '100%' }}>
            {t('contact.form.submit')}
            <Send size={20} />
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
